
































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import PhotoHeader from '../components/organization/PhotoHeader.vue'
import Main from '../components/organization/Main.vue'
import MiniCourse from '../components/miniCourse/index.vue'
import SectionCourse from '../components/organization/SectionCourse.vue'

import { Competicoes } from '@/storage/programacao/competicao'

@Component({
  components: {
    PhotoHeader,
    Main,
    MiniCourse
  }
})
export default class competicoes extends Vue {
  private all_competicoes: any

  private title = 'Competições'
  private background = 'assets/img/slider/logo-maratona.jpg'

  constructor() {
    super()

    this.all_competicoes = Competicoes
  }
}

